import { EntityValueType } from '../../../../common/types/shared/entitySelection';

// TODO: This is a placeholder implementation. We should probably have these values coming from the database or server-side configuration.
const enumValues: Record<EntityValueType, string[]> = {
  [EntityValueType.NUMBER]: [],
  [EntityValueType.BOOLEAN]: ['true', 'false'],
  [EntityValueType.DATE]: [],
  [EntityValueType.DATETIME]: [],
  [EntityValueType.STRING]: [],
  [EntityValueType.PERCENTAGE]: [],
  [EntityValueType.TEMPERATURE]: [],
  [EntityValueType.HUMIDITY]: [],
  [EntityValueType.PRESSURE]: [],
  [EntityValueType.VOLTAGE]: [],
  [EntityValueType.CURRENT]: [],
  [EntityValueType.POWER]: [],
  [EntityValueType.ENERGY]: [],
  [EntityValueType.FLOW_RATE]: [],
  [EntityValueType.CONCENTRATION]: [],
  [EntityValueType.LEVEL]: [],
  [EntityValueType.SPEED]: [],
  [EntityValueType.FREQUENCY]: [],
  [EntityValueType.AIRFLOW]: [],
  [EntityValueType.ENUM]: ['OPTION1', 'OPTION2', 'OPTION3'],
  [EntityValueType.PHYSICAL_ENUM]: [
    'PHYSICAL_OPTION1',
    'PHYSICAL_OPTION2',
    'PHYSICAL_OPTION3',
  ],
  [EntityValueType.ARRAY]: [],
  [EntityValueType.DURATION]: [],
  [EntityValueType.LATITUDE]: [],
  [EntityValueType.LONGITUDE]: [],
  [EntityValueType.COORDINATES]: [],
  [EntityValueType.STRING_ARRAY]: [],
  [EntityValueType.NUMBER_ARRAY]: [],
  [EntityValueType.BOOLEAN_ARRAY]: [],
  [EntityValueType.DATE_ARRAY]: [],
};

export const getPhysicalEnumValuesForType = (
  valueType: EntityValueType,
): string[] => {
  return enumValues[valueType] || [];
};
